// extracted by mini-css-extract-plugin
module.exports = {"root":"section_root__bgucO","withoutEmptyContent":"section_withoutEmptyContent__t4UjI","alignCenter":"section_alignCenter__OrJVh","main":"section_main__7fpsU"};